const uz = {
    meta: {
        title: "Ikki tilli SEO O'zbekiston: uz va ru so'rovlar | Innobek",
        description:
            "Ikki tilli SEO O'zbekistonda: qaysi sohada o'zbekcha, qaysida ruscha so'rov ustun, hreflang sozlash, Yandex, ikkinchi til narxi va qaytim muddati.",
        keywords: [
            "ikki tilli SEO O'zbekiston",
            "hreflang uz ru sozlash",
            "o'zbek tilida SEO qilish",
            "semantik yadro ikki tilda",
            "Yandex va Google O'zbekistonda",
            "sayt ikkinchi tili narxi",
        ],
    },
    h1: "Ikki tilli sayt va qidiruv: uz va ru so'rovlarni qanday bo'lib olish kerak",
    lead:
        "O'zbekistonda bitta ehtiyoj ikki xil so'rovga aylanadi va Google ular uchun ikki xil natija ro'yxatini chiqaradi. Ko'p kompaniya bitta til bilan ishlaydi va organik trafikning yarmini ko'rmaydi. Quyida qaysi sohada qaysi til ustun kelishini, texnik sxemani, narxni va qaytim muddatini ko'rib chiqamiz.",
    category: "SEO va o'sish",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Bizga kelgan saytlarning taxminan yarmida ikkinchi til bor, lekin u qidiruvda umuman ishlamaydi. Sabab tarjima sifatida emas — sahifalar tuzilmasida va texnik belgilarda. Natijada kompaniya ikkinchi til uchun pul to'lagan, ammo undan bitta ham ariza olmaydi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Nega bitta xizmat ikki tilda qidiriladi?" },
        {
            type: "p",
            text:
                "«Toshkentda stomatologiya narxi» va «стоматология Ташкент цена» — bu ikki alohida so'rov. Google ularga ikki xil natija ro'yxati bilan javob beradi va ular uchun ikki xil sahifani baholaydi. Ya'ni siz bitta bozor emas, ikkita bozor bilan ishlayapsiz.",
        },
        {
            type: "p",
            text:
                "Bitta sahifaga ikkala tilni aralashtirib qo'ysangiz, qidiruv tizimi sahifaning asosiy tilini aniq belgilay olmaydi. Natija — ikkala so'rovda ham o'rtacha pozitsiya. Buni tuzatish uchun yangi sayt shart emas: mavjud saytga to'g'ri tuzilma qo'shish yetadi.",
        },
        {
            type: "p",
            text:
                "Yana bir nozik joy — o'zbek tilining yozuvi. Amaliyotimizda lotin yozuvidagi so'rovlar ustunlik qiladi, lekin ayrim sohalarda kirill yozuvi ham sezilarli qoladi. Buni faraz qilmang: Search Console hisobotida o'z so'rovlaringizni ochib tekshiring.",
        },

        { type: "h2", text: "Qaysi sohada qaysi til ustun keladi?" },
        {
            type: "p",
            text:
                "Til bo'yicha aniq foizni beradigan rasmiy manba yo'q — biz uni topa olmadik va to'qib yozmaymiz. Lekin loyihalarimizdagi Search Console ma'lumotlari barqaror tendensiyani ko'rsatadi. Quyidagi jadval — sizning boshlang'ich farazingiz, yakuniy javob emas.",
        },
        {
            type: "table",
            head: ["Soha", "Odatda ustun til", "Nima uchun shunday", "Nimadan boshlash"],
            rows: [
                [
                    "Tibbiyot, klinika, dorixona",
                    "O'zbekcha",
                    "Bemor ko'pincha viloyatdan, so'rovni kundalik tilda yozadi",
                    "Xizmat sahifalarini avval o'zbekchada to'liq yozing",
                ],
                [
                    "Ta'lim, kurs, maktab",
                    "O'zbekcha",
                    "Qaror qabul qiluvchi — ota-ona, auditoriya juda keng",
                    "O'zbekcha savol-javob va blog bo'limi",
                ],
                [
                    "Qurilish, ta'mir, materiallar",
                    "O'zbekcha",
                    "Usta va xususiy buyurtmachi asosiy qidiruvchi",
                    "O'zbekcha narx sahifalari va kalkulyator",
                ],
                [
                    "IT, dasturiy ta'minot, B2B",
                    "Ruscha",
                    "Kasbiy atamalar ruschada shakllangan va shunday qidiriladi",
                    "Ruscha texnik sahifalar va keyslar",
                ],
                [
                    "Moliya, buxgalteriya, yuridik xizmat",
                    "Ruscha",
                    "Hujjat va qonun amaliyoti ko'p hollarda ruschada yuritiladi",
                    "Ruscha tahliliy maqolalar va hujjat namunalari",
                ],
                [
                    "Chakana savdo, xizmat ko'rsatish",
                    "Aralash",
                    "Auditoriya keng, ikkala til ham sezilarli ulushga ega",
                    "Ikkala tilni parallel olib boring",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Amaliy xulosa oddiy: agar sohangiz jadvalning yuqori uch qatoriga tushsa, byudjetni o'zbek tilidan boshlang. Pastki ikki qatorga tushsa — ruschadan. Aralash qatorda bo'lsangiz, ikkalasini birdaniga qilishga urinmang, avval o'lchang.",
        },

        { type: "h2", text: "O'z saytingizda til nisbatini qanday aniqlaysiz?" },
        {
            type: "p",
            text:
                "Bu ish bir soat vaqt oladi va bepul. Sizga faqat Google Search Console kerak. Agar u hali ulanmagan bo'lsa, birinchi qadam — uni ulash, chunki usiz SEO haqida gapirish mumkin emas.",
        },
        {
            type: "ol",
            items: [
                "Search Console'da «Effektivlik» hisobotini oching va davrni oxirgi 6 oyga qo'ying.",
                "«So'rovlar» yorlig'ida filtr qo'ying: kirill harflaridan biri bilan so'rovlarni ajrating — bu ruscha segmentingiz.",
                "Shu segmentning ko'rsatish va bosish sonini umumiy raqamdan ayiring — qolgani o'zbekcha va aralash segment.",
                "Endi «Sahifalar» yorlig'ini oching va shu ikki segment qaysi sahifalarga tushayotganini ko'ring. Agar ruscha so'rovlar o'zbekcha sahifaga tushayotgan bo'lsa — tuzilma xato.",
                "Oxirgi qadam: «O'rtacha pozitsiya» ustunini solishtiring. Qaysi tilda pozitsiya past bo'lsa, o'sish zaxirasi ham o'sha yerda.",
            ],
        },
        {
            type: "p",
            text:
                "Sayt hali yo'q bo'lsa, xuddi shu ishni Google Keyword Planner yoki Yandex Wordstat orqali qiling: bitta so'rovni ikki tilda kiritib, hajmlarni solishtiring. Bu aniq raqam bermaydi, lekin qaysi til og'irroq ekanini ko'rsatadi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Yandex'ni hisobga olish kerakmi?" },
        {
            type: "p",
            text:
                "O'zbekistonda Google ustun turadi, lekin ayrim sohalarda va ruszabon auditoriya orasida Yandex ulushi hali sezilarli. Shuning uchun uni butunlay chetlab o'tish — ruscha segmentning bir qismidan ixtiyoriy voz kechish demak.",
        },
        {
            type: "p",
            text:
                "Yaxshi yangilik shundaki, alohida byudjet deyarli kerak emas. Texnik holat, sahifa tezligi va kontent sifati ikkala tizim uchun bir xil foyda beradi. Qo'shimcha ish faqat sozlamada: Yandex Webmaster'ni ulash, sayt kartasini yuborish, mintaqani belgilash va indekslash xatolarini kuzatish.",
        },
        {
            type: "p",
            text:
                "Muhim farq bitta: Yandex ruscha morfologiya bilan yaxshi ishlaydi, lekin o'zbek tilini Google darajasida tushunmaydi. Shuning uchun o'zbekcha segment uchun Yandex'ga umid bog'lamang — u ruscha qismingiz uchun qo'shimcha kanal.",
        },

        { type: "h2", text: "URL sxemasi va hreflang: texnik qism" },
        {
            type: "p",
            text:
                "Bu bo'limni dasturchingizga ko'rsating — u yerda tayyor texnik topshiriq bor. Xatolarning katta qismi aynan shu to'rt bandda ketadi.",
        },
        {
            type: "list",
            items: [
                "Har til uchun alohida, doimiy URL bo'lsin. Masalan /xizmatlar/seo va /ru/uslugi/seo. Tilni cookie yoki IP bo'yicha almashtirib, URL'ni o'zgartirmaslik — eng ko'p uchraydigan xato: qidiruv tizimi ikkinchi versiyani umuman ko'rmaydi.",
                "Har juftlik o'zaro hreflang bilan bog'lansin va bu bog'lanish ikki tomonlama bo'lsin. O'zbekcha sahifa ruschaga ishora qilsa, ruscha ham o'zbekchaga ishora qilishi shart.",
                "x-default qiymatini belgilang — bu tili aniqlanmagan foydalanuvchi tushadigan versiya.",
                "Har sahifada o'z title, description va h1 bo'lsin. Tarjima qilingan title emas, o'sha tildagi so'rov asosida yozilgan title.",
                "Til almashtirish tugmasi foydalanuvchini bosh sahifaga emas, aynan shu sahifaning ikkinchi til versiyasiga olib borsin.",
                "Sayt kartasida ikkala til versiyasi ham bo'lsin va canonical har sahifada o'ziga ishora qilsin.",
            ],
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Agar sayt allaqachon ishlayotgan bo'lsa va ikkinchi til qo'shilayotgan bo'lsa, eski URL'larni o'zgartirmang. O'zgartirish zarur bo'lsa, 301 yo'naltirish qiling — aks holda yig'ilgan pozitsiyalarni yo'qotasiz.",
        },

        { type: "h2", text: "Avtomatik tarjima nega zarar qiladi?" },
        {
            type: "p",
            text:
                "Plagin orqali avtomatik tarjima qo'yish arzon ko'rinadi va shu sababli tez-tez tanlanadi. Muammo shundaki, u qidiruv uchun deyarli foydasiz va ba'zan zararli.",
        },
        {
            type: "p",
            text:
                "Birinchi sabab — tarjima so'rovni bilmaydi. Foydalanuvchi «сайт под ключ» deb qidiradi, avtomatik tarjima esa «сайт готовый» deb yozib qo'yadi. Sahifa mazmunan to'g'ri, lekin kerakli so'rov unda yo'q.",
        },
        {
            type: "p",
            text:
                "Ikkinchi sabab — ishonch. Tibbiyot, yuridik xizmat va moliya sohalarida g'aliz jumla arizani to'g'ridan-to'g'ri yo'qotadi. Bu yerda tejash boshqa joyda qimmatga tushadi.",
        },
        {
            type: "callout",
            text:
                "Amaliy qoida: avtomatik tarjimani faqat blog arxivi va yordamchi sahifalar uchun ishlating. Pul keltiradigan sahifalar — bosh sahifa, xizmat sahifalari va narx sahifasi — har doim qo'lda yozilsin.",
        },

        { type: "h2", text: "Ikkinchi til qancha turadi va qachon o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Ikkinchi tilni qo'shish yangi sayt qurishdan ancha arzon, chunki dizayn, kod va admin panel allaqachon bor. Asosiy xarajat — matn va texnik sozlash.",
        },
        {
            type: "table",
            head: ["Ish", "Nima kiradi", "Taxminiy narx", "Muddat"],
            rows: [
                [
                    "Texnik sozlash",
                    "URL sxemasi, hreflang, canonical, sayt kartasi, til tugmasi",
                    "2 000 000 – 4 000 000 so'm",
                    "3–7 ish kuni",
                ],
                [
                    "Ikkinchi til semantik yadrosi",
                    "So'rovlar yig'ish, niyat bo'yicha ajratish, sahifaga biriktirish",
                    "Audit paketi ichida, 3 500 000 so'mdan",
                    "5–10 ish kuni",
                ],
                [
                    "Asosiy sahifalar matni",
                    "Bosh sahifa va 8–12 ta xizmat sahifasi, qo'lda yozilgan",
                    "3 000 000 – 7 000 000 so'm",
                    "2–4 hafta",
                ],
                [
                    "Doimiy SEO yuritish",
                    "Ikkala til bo'yicha kontent, havolalar, hisobot",
                    "Oyiga 6 000 000 so'mdan",
                    "Uzluksiz",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Endi qaytim. Faraz qiling, bugun oyiga 600 ta organik tashrif olayapsiz va bularning hammasi bitta tildan. Ikkinchi til o'z sohangizda taxminan yarim hajmni beradi deb olsak, olti oydan keyin qo'shimcha 250–300 tashrif chiqadi.",
        },
        {
            type: "ol",
            items: [
                "Qo'shimcha 280 tashrif, saytdagi konversiya 3% — oyiga 8 ta yangi ariza.",
                "Arizadan shartnomaga o'tish 20% — oyiga 1,6 ta mijoz.",
                "O'rtacha chek 6 000 000 so'm, marja 30% — bitta mijozdan 1 800 000 so'm sof foyda.",
                "Oylik qo'shimcha foyda: 1,6 × 1 800 000 ≈ 2 900 000 so'm.",
                "Boshlang'ich xarajat 9 000 000 so'm atrofida bo'lsa, u taxminan 5–8 oyda qoplanadi — lekin bu oylar natija chiqqandan keyin sanaladi.",
            ],
        },
        {
            type: "p",
            text:
                "Shu yerda eng muhim ogohlantirish: SEO tez natija bermaydi. Birinchi sezilarli o'zgarishlar odatda 2–3 oydan oldin ko'rinmaydi, jiddiy o'sish esa 5–9 oy oralig'ida keladi. Ya'ni yuqoridagi hisobning nol nuqtasi — shartnoma imzolangan kun emas, trafik o'sa boshlagan oy.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Hech narsa qilmaslikning narxi qancha?" },
        {
            type: "p",
            text:
                "Ikkinchi tilni qo'shmaslik hisobda ko'rinmaydigan xarajat. Uni taxminan hisoblash mumkin: yuqoridagi misolda bu oyiga 2,9 mln so'm qo'lga kirmagan foyda, ya'ni yiliga 35 mln so'mdan ortiq.",
        },
        {
            type: "p",
            text:
                "Ikkinchi yo'qotish ko'rinmasroq. Raqobatchingiz ikkinchi tilni bugun qo'shsa, u so'rovlarni egallab oladi va keyin uni siqib chiqarish ikki barobar ko'p vaqt oladi. Qidiruvda birinchi bo'lish arzonroq, quvib yetish qimmatroq.",
        },

        { type: "h2", text: "Ikki tilli SEO qachon sizga mos emas?" },
        {
            type: "p",
            text:
                "Bu bo'limni yozish biz uchun foydali emas, lekin usiz maqola halol bo'lmaydi. Quyidagi holatlarda ikkinchi tilga pul sarflamang.",
        },
        {
            type: "list",
            items: [
                "Birinchi tilingiz hali to'liq ishlamaydi. Agar asosiy tilda ham pozitsiya yo'q bo'lsa, ikkinchi til muammoni ikkilantiradi, yechmaydi.",
                "Auditoriyangiz aniq bir tilga bog'langan. Masalan, faqat viloyat bozori bilan ishlaydigan qishloq xo'jaligi kompaniyasiga ruscha versiya deyarli hech narsa bermaydi.",
                "Sotuvingiz tender yoki bitta yirik xaridor orqali ketadi. Bu yerda qidiruv trafigi qaror qabul qilishga ta'sir qilmaydi.",
                "Ikkinchi tilda kontentni yangilashga odam yo'q. Yarim tashlangan til versiyasi butunlay yo'q versiyadan yomonroq — u ishonchni tushiradi.",
                "Sizga natija shu oyda kerak. Bu holatda avval Google Ads'ni ikkala tilda ishga tushiring, SEO'ni parallel olib boring.",
            ],
        },
        {
            type: "quote",
            text:
                "Ikkinchi til — tarjima loyihasi emas, ikkinchi bozorga chiqish. Shuning uchun uni matn hajmi bilan emas, ariza soni bilan o'lchang.",
        },
    ],

    faq: [
        {
            q: "Ikki tilli sayt uchun alohida domen kerakmi?",
            a: "Yo'q, aksariyat holatda kerak emas. Bitta domen ichida til papkasi (/ va /ru/) yetarli va bu eng arzon hamda eng barqaror sxema. Alohida domen faqat boshqa mamlakat bozoriga chiqayotganingizda mantiqiy. Ikkita domen ikki barobar ko'p texnik xizmat, ikki barobar ko'p havola ishi va ikki barobar ko'p byudjet degani.",
        },
        {
            q: "Bitta sahifada ikkala tilni yozsam bo'ladimi?",
            a: "Bu eng ko'p uchraydigan xato. Aralash sahifada qidiruv tizimi asosiy tilni aniq belgilay olmaydi va ikkala so'rov guruhida ham o'rtacha pozitsiya beradi. Natijada siz ikkala bozorni ham yarmigacha yo'qotasiz. To'g'ri yechim — har til uchun alohida URL, alohida title va hreflang bilan o'zaro bog'langan juftlik.",
        },
        {
            q: "Qaysi tildan boshlash kerak?",
            a: "Sohangizga qarang. Tibbiyot, ta'lim va qurilishda odatda o'zbek tili og'irroq keladi; IT, moliya va B2B yo'nalishlarida ruscha so'rovlar ustun. Lekin farazga tayanmang: Search Console'dagi oxirgi olti oy so'rovlarini kirill va lotin bo'yicha ajratib chiqing. Bu bir soatlik ish va u butun byudjet taqsimotini belgilaydi.",
        },
        {
            q: "Natijani qancha vaqtda kutish kerak?",
            a: "Ikkinchi til qo'shilgandan keyin birinchi sezilarli o'zgarishlar 2–3 oydan oldin ko'rinmaydi. Sezilarli trafik o'sishi odatda 5–9 oy oralig'ida keladi, raqobati yuqori sohalarda bu muddat bir yilgacha cho'ziladi. Birinchi oyda faqat indekslangan sahifalar soni va texnik ko'rsatkichlar o'zgaradi — bu normal holat.",
        },
        {
            q: "Avtomatik tarjima plaginini qo'ysam bo'ladimi?",
            a: "Blog arxivi va yordamchi sahifalar uchun bo'ladi. Pul keltiradigan sahifalarga esa yaramaydi: tarjima real so'rovni bilmaydi va sahifada kerakli iborani umuman qoldirmaydi. Bundan tashqari g'aliz jumla tibbiyot, yuridik va moliya sohalarida arizani to'g'ridan-to'g'ri yo'qotadi. Asosiy sahifalarni har doim qo'lda yozdiring.",
        },
        {
            q: "Yandex uchun alohida byudjet ajratish kerakmi?",
            a: "Odatda kerak emas. Texnik holat, sayt tezligi va kontent sifati bo'yicha qilingan ish ikkala tizimga ham baravar foyda beradi. Qo'shimcha ish faqat sozlashda: Yandex Webmaster'ni ulash, sayt kartasini yuborish, mintaqani belgilash va indekslash xatolarini kuzatish. Yandex sizga asosan ruscha segment bo'yicha qo'shimcha trafik beradi.",
        },
    ],

    cta: {
        h: "Qaysi til sizga ko'proq pul keltirishini bepul aniqlaymiz",
        p:
            "Search Console ma'lumotingizni ochib, so'rovlarni til bo'yicha ajratamiz va qaysi tomonda o'sish zaxirasi borligini raqam bilan ko'rsatamiz. Ikkinchi til sizga hozir kerak emas deb hisoblasak, buni ham ochiq aytamiz.",
        button: "Bepul tahlil olish",
    },

    images: [
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Google qidiruv natijasi va sayt trafigi o'sishini ko'rsatuvchi ko'rsatkichlar paneli",
            caption: "Ikki til — ikkita alohida natija ro'yxati va ikkita alohida trafik oqimi",
        },
        {
            src: "/assets/img/blog/ikki-tilli-seo-hreflang.webp",
            alt: "Ikki tilli sayt tuzilmasi va sahifalar orasidagi hreflang juftliklari sxemasi",
            caption: "Har juftlik ikki tomonlama bog'lanishi shart — eng ko'p xato shu yerda ketadi",
            prompt:
                "URL and hreflang structure diagram: two parallel site trees, one under a root path and one under a /ru/ path, linked by paired bidirectional hreflang arrows between equivalent pages, plus an x-default marker on one node; clean technical line diagram, blue and teal on light background, no readable text labels, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ikki-tilli-seo-semantika.webp",
            alt: "So'rovlarni ikki til va foydalanuvchi niyati bo'yicha taqsimlash jadvali",
            caption: "Semantik yadro tilga emas, niyatga qarab sahifalarga biriktiriladi",
            prompt:
                "Keyword split worksheet: a two-column table with Latin-script and Cyrillic-script query columns, intent tags (informational, commercial) and a target-page column; clean light spreadsheet UI, blue header row, blurred placeholder text, no readable copy, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/cleanza-seo.webp",
            alt: "Cleanza loyihasida qidiruv optimizatsiyasidan keyingi trafik natijasi",
            caption: "Real loyiha: organik o'sish birinchi oydan emas, uchinchi oydan boshlanadi",
        },
    ],

    relatedServices: ["seo", "google-ads", "korporativ-saytlar"],
    relatedPosts: ["google-business-profil-yaqin-atrofda", "ariza-tannarxi-seo-ads-instagram", "web-sayt"],
};

const ru = {
    meta: {
        title: "Двуязычное SEO в Узбекистане: uz и ru запросы | Innobek",
        description:
            "Двуязычное SEO в Узбекистане: где выигрывает узбекский, где русский, настройка hreflang, Яндекс, стоимость второй языковой версии и сроки окупаемости.",
        keywords: [
            "двуязычное SEO Узбекистан",
            "hreflang для узбекского и русского",
            "продвижение сайта на узбекском языке",
            "семантическое ядро на двух языках",
            "SEO под Яндекс в Узбекистане",
            "стоимость второй языковой версии",
        ],
    },
    h1: "Двуязычный сайт и поиск: как разделить uz- и ru-запросы",
    lead:
        "В Узбекистане одна и та же потребность превращается в два разных запроса, и поиск выдаёт по ним два разных списка результатов. Многие компании работают с одним языком и не видят половину органического трафика. Разбираем, где какой язык выигрывает, как устроена техническая часть, сколько это стоит и когда окупается.",
    category: "SEO и рост",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Примерно у половины сайтов, которые к нам приходят, вторая языковая версия есть — но в поиске она не работает вообще. Причина не в качестве перевода, а в структуре страниц и технических метках. В итоге компания за вторую версию заплатила, а заявок с неё не получает ни одной.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Почему одну и ту же услугу ищут на двух языках?" },
        {
            type: "p",
            text:
                "«Toshkentda stomatologiya narxi» и «стоматология Ташкент цена» — это два самостоятельных запроса. Поиск отвечает на них разными списками результатов и оценивает для них разные страницы. То есть вы работаете не с одним рынком, а с двумя.",
        },
        {
            type: "p",
            text:
                "Если смешать оба языка на одной странице, поисковая система не сможет однозначно определить её основной язык. Результат — средняя позиция по обоим запросам. Чтобы это исправить, новый сайт не нужен: достаточно добавить правильную структуру к существующему.",
        },
        {
            type: "p",
            text:
                "Есть и более тонкий момент — письменность узбекского языка. В наших проектах преобладает латиница, но в отдельных нишах заметная доля запросов остаётся на кириллице. Не угадывайте: откройте отчёт Search Console и посмотрите на свои реальные запросы.",
        },

        { type: "h2", text: "Где выигрывает узбекский, а где русский?" },
        {
            type: "p",
            text:
                "Официального источника с точными долями по языкам мы не нашли — и придумывать цифры не будем. Но данные Search Console по нашим проектам показывают устойчивую закономерность. Таблица ниже — это ваша стартовая гипотеза, а не окончательный ответ.",
        },
        {
            type: "table",
            head: ["Ниша", "Обычно преобладает", "Почему так", "С чего начинать"],
            rows: [
                [
                    "Медицина, клиники, аптеки",
                    "Узбекский",
                    "Пациент часто из региона и формулирует запрос на бытовом языке",
                    "Сначала полностью закрыть услуги на узбекском",
                ],
                [
                    "Образование, курсы, школы",
                    "Узбекский",
                    "Решение принимает родитель, аудитория максимально широкая",
                    "Раздел вопросов и ответов на узбекском",
                ],
                [
                    "Строительство, ремонт, материалы",
                    "Узбекский",
                    "Ищут в основном мастера и частные заказчики",
                    "Страницы цен и калькулятор на узбекском",
                ],
                [
                    "IT, ПО, B2B-услуги",
                    "Русский",
                    "Профессиональная терминология закрепилась в русском варианте",
                    "Технические страницы и кейсы на русском",
                ],
                [
                    "Финансы, бухгалтерия, юристы",
                    "Русский",
                    "Документооборот и правоприменение чаще ведутся на русском",
                    "Аналитические статьи и образцы документов",
                ],
                [
                    "Розница и бытовые услуги",
                    "Смешанно",
                    "Аудитория широкая, оба языка дают заметную долю",
                    "Вести обе версии параллельно",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Практический вывод простой. Если ваша ниша в верхних трёх строках — начинайте бюджет с узбекского. Если в нижних двух — с русского. Если вы в смешанной строке, не беритесь за оба языка сразу: сначала измерьте.",
        },

        { type: "h2", text: "Как определить языковой баланс на своём сайте?" },
        {
            type: "p",
            text:
                "Эта работа занимает около часа и ничего не стоит. Нужен только Google Search Console. Если он ещё не подключён, это и есть первый шаг — без него разговор о SEO бессмыслен.",
        },
        {
            type: "ol",
            items: [
                "Откройте отчёт «Эффективность» и выставьте период в шесть месяцев.",
                "На вкладке «Запросы» отфильтруйте строки, содержащие кириллические символы, — это ваш русскоязычный сегмент.",
                "Вычтите его показы и клики из общей суммы: остаток — узбекоязычный и смешанный сегмент.",
                "Перейдите на вкладку «Страницы» и посмотрите, на какие URL приходят эти два сегмента. Если русские запросы приходят на узбекскую страницу, значит, структура собрана неверно.",
                "Последний шаг: сравните среднюю позицию по сегментам. Где позиция ниже, там и находится основной запас роста.",
            ],
        },
        {
            type: "p",
            text:
                "Если сайта ещё нет, сделайте то же самое через Google Keyword Planner или Яндекс Wordstat: введите один и тот же запрос на двух языках и сравните объёмы. Точной цифры это не даст, но покажет, какая сторона тяжелее.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Нужно ли учитывать Яндекс?" },
        {
            type: "p",
            text:
                "В Узбекистане Google доминирует, но в отдельных нишах и среди русскоязычной аудитории доля Яндекса всё ещё заметна. Полностью игнорировать его — значит добровольно отказаться от части русскоязычного сегмента.",
        },
        {
            type: "p",
            text:
                "Хорошая новость: отдельный бюджет почти не нужен. Техническое состояние, скорость страниц и качество контента работают одинаково на обе системы. Дополнительная работа только в настройке: подключить Яндекс Вебмастер, отправить карту сайта, задать регион и следить за ошибками индексации.",
        },
        {
            type: "p",
            text:
                "Одно важное отличие: Яндекс хорошо разбирает русскую морфологию, но узбекский понимает заметно хуже, чем Google. Поэтому на узбекский сегмент через Яндекс рассчитывать не стоит — это дополнительный канал именно для русской части.",
        },

        { type: "h2", text: "Схема URL и hreflang: техническая часть" },
        {
            type: "p",
            text:
                "Этот раздел можно передать разработчику как готовое техническое задание. Большая часть ошибок возникает ровно в этих пунктах.",
        },
        {
            type: "list",
            items: [
                "У каждого языка должен быть собственный постоянный URL — например /uslugi/seo и /ru/uslugi/seo. Переключение языка по cookie или IP без смены адреса — самая частая ошибка: вторую версию поиск просто не видит.",
                "Каждая пара страниц связывается через hreflang, и связь должна быть двусторонней. Если узбекская страница ссылается на русскую, русская обязана ссылаться на узбекскую.",
                "Задайте значение x-default — это версия для пользователя, чей язык определить не удалось.",
                "У каждой страницы собственные title, description и h1. Не переведённый title, а написанный под реальный запрос на этом языке.",
                "Переключатель языка должен вести на ту же страницу в другой версии, а не на главную.",
                "В карте сайта должны быть обе версии, а canonical на каждой странице указывает на саму себя.",
            ],
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Если сайт уже работает и вторая версия только добавляется, не меняйте существующие URL. Когда изменение неизбежно, настраивайте 301-редирект — иначе накопленные позиции обнулятся.",
        },

        { type: "h2", text: "Чем вреден автоматический перевод?" },
        {
            type: "p",
            text:
                "Плагин автоперевода выглядит дешёвым решением и поэтому выбирается чаще всего. Проблема в том, что для поиска он почти бесполезен, а иногда прямо вреден.",
        },
        {
            type: "p",
            text:
                "Первая причина — перевод не знает запроса. Пользователь ищет «сайт под ключ», а автоперевод формулирует «готовый сайт». Смысл сохранён, но нужной фразы на странице нет.",
        },
        {
            type: "p",
            text:
                "Вторая причина — доверие. В медицине, юридических услугах и финансах корявая формулировка напрямую убивает заявку. Экономия здесь оборачивается расходом в другом месте.",
        },
        {
            type: "callout",
            text:
                "Рабочее правило: автоперевод допустим только для архива блога и вспомогательных страниц. Страницы, которые приносят деньги, — главная, услуги и цены — всегда пишутся вручную.",
        },

        { type: "h2", text: "Сколько стоит вторая версия и когда она окупится?" },
        {
            type: "p",
            text:
                "Добавить второй язык заметно дешевле, чем построить новый сайт: дизайн, код и админ-панель уже есть. Основные расходы — тексты и техническая настройка.",
        },
        {
            type: "table",
            head: ["Работа", "Что входит", "Ориентир по цене", "Срок"],
            rows: [
                [
                    "Техническая настройка",
                    "Схема URL, hreflang, canonical, карта сайта, переключатель",
                    "2 000 000 – 4 000 000 сум",
                    "3–7 рабочих дней",
                ],
                [
                    "Семантика второго языка",
                    "Сбор запросов, разбор по интенту, привязка к страницам",
                    "В составе аудита, от 3 500 000 сум",
                    "5–10 рабочих дней",
                ],
                [
                    "Тексты ключевых страниц",
                    "Главная и 8–12 страниц услуг, написанных вручную",
                    "3 000 000 – 7 000 000 сум",
                    "2–4 недели",
                ],
                [
                    "Постоянное ведение SEO",
                    "Контент, ссылки и отчётность по обеим версиям",
                    "От 6 000 000 сум в месяц",
                    "Непрерывно",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Теперь про окупаемость. Допустим, сегодня вы получаете 600 органических визитов в месяц и все они приходят с одного языка. Если принять, что вторая версия в вашей нише даёт примерно половину объёма, через полгода добавятся 250–300 визитов.",
        },
        {
            type: "ol",
            items: [
                "Дополнительные 280 визитов при конверсии сайта 3% — это 8 новых заявок в месяц.",
                "Переход из заявки в сделку 20% — 1,6 клиента в месяц.",
                "Средний чек 6 000 000 сум при марже 30% — 1 800 000 сум чистой прибыли с клиента.",
                "Дополнительная прибыль: 1,6 × 1 800 000 ≈ 2 900 000 сум в месяц.",
                "При стартовых вложениях около 9 000 000 сум окупаемость наступает примерно за 5–8 месяцев — но этот отсчёт начинается после появления результата.",
            ],
        },
        {
            type: "p",
            text:
                "И здесь главное предупреждение: SEO не даёт быстрого результата. Первые заметные изменения обычно не появляются раньше 2–3 месяцев, серьёзный рост приходит в диапазоне 5–9 месяцев. То есть нулевая точка расчёта — не день подписания договора, а месяц, когда трафик начал расти.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Сколько стоит ничего не делать?" },
        {
            type: "p",
            text:
                "Отсутствие второй версии — это расход, которого нет в отчётности. Его можно оценить: в примере выше это 2,9 млн сум недополученной прибыли в месяц, то есть более 35 млн сум за год.",
        },
        {
            type: "p",
            text:
                "Вторая потеря менее очевидна. Если конкурент добавит второй язык сегодня, он займёт запросы, и вытеснить его потом будет вдвое дольше. Быть первым в поиске дешевле, чем догонять.",
        },

        { type: "h2", text: "Когда двуязычное SEO вам не нужно?" },
        {
            type: "p",
            text:
                "Писать этот раздел нам невыгодно, но без него материал был бы нечестным. В перечисленных ниже ситуациях деньги на вторую версию тратить не стоит.",
        },
        {
            type: "list",
            items: [
                "Первый язык ещё не работает. Если позиций нет и в основной версии, вторая удвоит проблему, а не решит её.",
                "Аудитория жёстко привязана к одному языку. Сельхозкомпании, работающей только с областным рынком, русская версия почти ничего не даст.",
                "Продажи идут через тендеры или одного крупного покупателя. Поисковый трафик на решение здесь не влияет.",
                "Некому вести контент на втором языке. Наполовину заброшенная версия хуже, чем её отсутствие: она снижает доверие.",
                "Результат нужен в этом месяце. Тогда сначала запускайте Google Ads на обоих языках, а SEO ведите параллельно.",
            ],
        },
        {
            type: "quote",
            text:
                "Второй язык — это не проект перевода, а выход на второй рынок. Поэтому измерять его нужно не объёмом текста, а количеством заявок.",
        },
    ],

    faq: [
        {
            q: "Нужен ли отдельный домен под вторую языковую версию?",
            a: "В большинстве случаев нет. Языковая папка внутри одного домена (/ и /ru/) — самая дешёвая и устойчивая схема. Отдельный домен оправдан только при выходе на рынок другой страны. Два домена означают вдвое больше технического обслуживания, вдвое больше работы со ссылками и, соответственно, вдвое больший бюджет на продвижение.",
        },
        {
            q: "Можно ли разместить оба языка на одной странице?",
            a: "Это самая частая ошибка. На смешанной странице поисковая система не определяет основной язык однозначно и выдаёт среднюю позицию по обеим группам запросов. В итоге вы теряете примерно половину каждого рынка. Правильное решение — отдельный URL под каждый язык, собственный title и пара страниц, связанная через hreflang.",
        },
        {
            q: "С какого языка начинать?",
            a: "Смотрите на нишу. В медицине, образовании и строительстве обычно тяжелее узбекский; в IT, финансах и B2B преобладают русские запросы. Но не опирайтесь на гипотезу: разделите запросы последних шести месяцев в Search Console по кириллице и латинице. Это час работы, и он определяет всё распределение бюджета.",
        },
        {
            q: "Через какое время ждать результата?",
            a: "После подключения второй версии первые заметные изменения появляются не раньше 2–3 месяцев. Ощутимый рост трафика обычно приходит в диапазоне 5–9 месяцев, а в высококонкурентных нишах срок растягивается до года. В первый месяц меняются только технические показатели и число проиндексированных страниц — это нормально.",
        },
        {
            q: "Можно ли обойтись плагином автоперевода?",
            a: "Для архива блога и вспомогательных страниц — можно. Для страниц, которые приносят деньги, — нет: перевод не знает реального запроса и просто не оставляет нужную формулировку на странице. Плюс корявый язык напрямую убивает заявку в медицине, юридических услугах и финансах. Ключевые страницы всегда пишутся вручную.",
        },
        {
            q: "Нужен ли отдельный бюджет под Яндекс?",
            a: "Как правило, нет. Работа над техническим состоянием, скоростью и качеством контента одинаково полезна обеим системам. Дополнительные действия сводятся к настройке: подключить Яндекс Вебмастер, отправить карту сайта, указать регион и отслеживать ошибки индексации. Дополнительный трафик Яндекс даст в основном по русскоязычному сегменту.",
        },
    ],

    cta: {
        h: "Бесплатно посчитаем, какой язык приносит вам больше денег",
        p:
            "Посмотрим данные вашего Search Console, разделим запросы по языкам и покажем цифрами, где находится запас роста. Если решим, что вторая версия вам сейчас не нужна, скажем об этом прямо.",
        button: "Получить бесплатный разбор",
    },

    images: [
        {
            src: "/assets/img/blog/web-seo.webp",
            alt: "Результаты поиска Google и панель показателей роста трафика сайта",
            caption: "Два языка — это два отдельных списка выдачи и два отдельных потока трафика",
        },
        {
            src: "/assets/img/blog/ikki-tilli-seo-hreflang.webp",
            alt: "Схема структуры двуязычного сайта и парных связей hreflang между страницами",
            caption: "Каждая пара связывается в обе стороны — именно здесь возникает большинство ошибок",
            prompt:
                "URL and hreflang structure diagram: two parallel site trees, one under a root path and one under a /ru/ path, linked by paired bidirectional hreflang arrows between equivalent pages, plus an x-default marker on one node; clean technical line diagram, blue and teal on light background, no readable text labels, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ikki-tilli-seo-semantika.webp",
            alt: "Таблица распределения запросов по двум языкам и типу пользовательского интента",
            caption: "Семантика привязывается к страницам по интенту, а не по языку",
            prompt:
                "Keyword split worksheet: a two-column table with Latin-script and Cyrillic-script query columns, intent tags (informational, commercial) and a target-page column; clean light spreadsheet UI, blue header row, blurred placeholder text, no readable copy, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/cleanza-seo.webp",
            alt: "Результат поисковой оптимизации в проекте Cleanza — динамика органического трафика",
            caption: "Реальный проект: органический рост начинается не с первого месяца, а с третьего",
        },
    ],

    relatedServices: ["seo", "google-ads", "korporativ-saytlar"],
    relatedPosts: ["google-business-profil-yaqin-atrofda", "ariza-tannarxi-seo-ads-instagram", "web-sayt"],
};

const content = { uz, ru };

export default content;
